import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import translator from ".//translator";

export function useXhrCaller(params) {
	const [result, setResult] = useState(null);
	const token = useSelector((state) => state.session.token);
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);
	const toastMessage = useCallback(() => {}, [currentLanguage]);

	useEffect(() => {
		async function fetchMyAPI() {
			let response = await xhrCaller(params);
			setResult(response);
		}
		if (params) {
			params.bearer = params.bearer ?? token;
			fetchMyAPI(params, "EN");
		}
	}, [params]);

	return result;
}

export const xhrCaller = (params, lang) => {
	let actionName = params?.action?.replaceAll("/", "-");
	if (!navigator.onLine) {
		return {
			error: true,
			result: null,
			action: actionName,
		};
	}

	if (!params) {
		return {
			error: "No params for xhrCaller",
			result: null,
			action: params?.action?.replaceAll("/", " "),
		};
	}
	if (!params.method) {
		params.method = "get";
	}

	var server = "";
	switch (params.srv) {
		case "api":
			server = `${process.env.REACT_APP_SERVER_URL}`;
			break;
		case "wado":
			server = `${process.env.REACT_APP_IMAGE_SERVER_URL}`;
			break;
		default:
			break;
	}
	if (
		params.contentType === "multipart/form-data" &&
		params.method.toLowerCase() === "post"
	) {
		return fetch(server + params.action, {
			method: "POST",
			body: params.data,
			headers: {
				Authorization: "Bearer " + params.bearer,
			},
		})
			.then((resp) => {
				if (resp.ok) {
					return resp.json();
				}
				return {
					error: resp,
					result: null,
					action: params?.action?.replaceAll("/", " "),
				};
			})
			.then((json) => {
				return {
					error: null,
					result: json,
					action: params?.action?.replaceAll("/", " "),
				};
			})
			.catch((error) => {
				return {
					error: error,
					result: null,
					action: params?.action?.replaceAll("/", " "),
				};
			});
	} else {
		return new Promise((resolve, reject) => {
			try {
				var xhr = new XMLHttpRequest();
				xhr.withCredentials = false;

				var qstring = "";
				if (params.method.toLowerCase() === "get" && params.data) {
					let sendObj = { ...params.data };
					if (
						!(typeof sendObj.flt === "string" || sendObj.flt instanceof String)
					) {
						sendObj.flt = encodeURIComponent(new URLSearchParams(sendObj.flt));
					}
					delete sendObj.callback;

					qstring =
						Object.keys(sendObj).length > 0
							? "?" +
							  Object.keys(sendObj)
									?.filter(
										(key) => sendObj[key] !== undefined && sendObj[key] !== null
									)
									?.map((key) =>
										Array.isArray(sendObj[key])
											? sendObj[key].join("&" + key + "=" + sendObj[key])
											: key + "=" + sendObj[key]
									)
									.join("&")
							: "";
				}
				if (
					params.method.toLowerCase() === "post" &&
					params.data &&
					!params?.contentType?.length
				) {
					params.data = JSON.stringify(params.data);
				}
				xhr.open(params.method, server + params.action + qstring);

				if (params.contentType !== false) {
					if (params.contentType?.length) {
						xhr.setRequestHeader("content-type", params.contentType);
					} else {
						xhr.setRequestHeader("content-type", "application/json");
					}
				}
				let parseJson = true;
				if (params.accept?.length) {
					xhr.setRequestHeader("accept", params.accept);
				}
				if (params.responseType?.length) {
					xhr.responseType = params.responseType;
				}
				if (params?.json === false) {
					parseJson = false;
				}

				xhr.onload = function () {
					try {
						if (
							params.method.toLowerCase() !== "get" &&
							params.action !== "Account/UpdateUserPreference"
						) {
							window.imedAjaxLastCallOutPost = new Date();
						}
						if (params.method.toLowerCase() === "get") {
							window.imedAjaxLastCallOutGet = new Date();
							//yield put(HideLoader());
						}
						let result = null;
						if (xhr.status < 200 || xhr.status >= 300) {
							try {
								if (parseJson) {
									var jsonResult = JSON.parse(xhr.response);
									result = {
										message:
											jsonResult?.title + JSON.stringify(jsonResult?.errors),
									};
								}
							} catch {}
							resolve({
								error: xhr.statusText,
								result: result,
								action: params?.action?.replaceAll("/", " "),
							});
						} else {
							result = xhr.response;
							if (parseJson) {
								result = JSON.parse(xhr.response);
							}
						}

						resolve({
							error: null,
							result: result,
							action: params?.action?.replaceAll("/", " "),
						});
					} catch (e) {
						console.error("Error onload xhr-caller");
						console.error(e);
						resolve({ result: null, error: e });
					}
				};
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
						var errorMsg = "";
						if (xhr.status == 401) {
							errorMsg = "Not authorized, please login";
						}
						if (xhr.status == 403) {
							errorMsg = "Not authorized, please login";
						}
						if (errorMsg !== "") {
							resolve({
								error: { code: xhr.status, title: errorMsg, message: errorMsg },
								result: null,
								action: params?.action?.replaceAll("/", " "),
							});
						}
					}
				};
				xhr.ontimeout = function () {
					toast.error(actionName + "Please try again, no reponse from server.");
					resolve({
						error: {
							code: "000",
							response: "Please try again, no reponse from server.",
						},
						result: null,
						action: params?.action?.replaceAll("/", " "),
					});
				};
				xhr.onerror = function (error) {
					resolve({
						error,
						result: null,
						action: params?.action?.replaceAll("/", " "),
					});
				};

				if (params.bearer) {
					xhr.setRequestHeader("Authorization", "Bearer " + params.bearer);
				}
				if (params.method.toLowerCase() !== "get") {
					window.imedAjaxLastCallInPost = new Date();
				} else {
					window.imedAjaxLastCallInGet = new Date();
				}
				xhr.send(params.data);
			} catch (e) {
				console.error("Error in xhr-caller");
				console.error(e);
				resolve({ result: null, error: e });
			}
		});
	}
};

export default xhrCaller;
